import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DwComponent, DwComponentType } from '@devwareapps/devware-cap';
import { LadderView, TierPipView } from '../../models/achievement.model';
import { GamificationWeekDayView, mapAchievementToLadder, mapGamificationWeek } from '../../models/gamification-view.mapper';
import { GamificationRepositoryService } from '../../services/gamification-repository.service';

@DwComponent({
  componentType: DwComponentType.pageComponent,
  key: 'achievements-page',
  name: 'Achievements Page',
  isGlobal: true
})
@Component({
  selector: 'app-achievements-page',
  templateUrl: './achievements-page.component.html',
  styleUrls: ['./achievements-page.component.scss']
})
export class AchievementsPageComponent implements OnInit, OnDestroy {
  weatherDayCopy = 'One weather day is granted each week. Unused days carry over, up to a balance of two.';

  streakCount = 0;
  longestStreak = 0;
  weatherDaysAvailable = 0;
  weekDays: GamificationWeekDayView[] = [];
  weekSummary = '0 of 7 days completed';
  ladders: LadderView[] = [];
  earnedTierCount = 0;
  totalTierCount = 0;
  tiersEarnedLabel = '0 of 0 tiers earned';
  selectedLadder?: LadderView;
  overviewLoading = true;
  laddersLoading = true;
  readonly ladderSkeletons = [1, 2, 3, 4];

  constructor(private readonly gamificationRepositoryService: GamificationRepositoryService) { }

  ngOnInit(): void {
    this.gamificationRepositoryService.getOverview().subscribe(bootstrap => {
      this.overviewLoading = false;
      if (!bootstrap?.IsAvailable) {
        return;
      }

      this.streakCount = bootstrap.Summary?.CurrentProtectedStreakDays || 0;
      this.longestStreak = bootstrap.Summary?.LongestProtectedStreakDays || 0;
      this.weatherDaysAvailable = bootstrap.Summary?.WeatherDayBalance || 0;
      const configuration = bootstrap.Configuration;
      const grantQuantity = configuration?.WeatherDayGrantQuantity || 1;
      this.weatherDayCopy = `${grantQuantity} weather ${grantQuantity === 1 ? 'day is' : 'days are'} granted each week. Unused days carry over, up to a balance of ${configuration?.WeatherDayMaximumBalance || 2}.`;
      this.weekDays = mapGamificationWeek(bootstrap.CurrentWeek, new Date(), bootstrap.Configuration?.WeekStartDay || 0);
      this.weekSummary = `${this.weekDays.filter(day => day.completed).length} of ${this.weekDays.length} days completed`;
    }, () => this.overviewLoading = false);

    this.gamificationRepositoryService.getAchievements().subscribe(achievements => {
      this.laddersLoading = false;
      this.ladders = (achievements || []).map(mapAchievementToLadder);
      this.earnedTierCount = (achievements || [])
        .reduce((total, achievement) => total + (achievement.Tiers || []).filter(tier => tier.Earned).length, 0);
      this.totalTierCount = (achievements || [])
        .reduce((total, achievement) => total + (achievement.Tiers || []).length, 0);
      this.tiersEarnedLabel = `${this.earnedTierCount} of ${this.totalTierCount} tiers earned`;
    }, () => this.laddersLoading = false);
  }

  openLadder(ladder: LadderView): void {
    this.selectedLadder = ladder;
    document.body.style.overflow = 'hidden';
  }

  closeLadder(): void {
    this.selectedLadder = undefined;
    document.body.style.overflow = '';
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeLadder();
  }

  trackByDayKey(index: number, day: GamificationWeekDayView): string {
    return day.key;
  }

  trackByLadderKey(index: number, ladder: LadderView): string {
    return ladder.key;
  }

  trackByPipKey(index: number, pip: TierPipView): string {
    return pip.key;
  }
}
